<template>
  <span v-html="text"></span>
</template>

<script>
export default {
  props: ['text']
}
</script>
